import { useState, useEffect } from "react";
import { getBase64 } from "../helper/image-helper";
import { VelavuFloor, VelavuFloorImage } from "velavu-js-api";

export interface ImageDimensions {
	width: number;
	height: number;
}

export default interface UserImageData {
	name: string;
	renderable: Blob | string;
	dimensions: ImageDimensions;
}

export function useUserImageDataURL(renderable: Blob | string): string;
export function useUserImageDataURL(renderable: undefined): undefined;
export function useUserImageDataURL(
	renderable: Blob | string | undefined,
): string | undefined;
export function useUserImageDataURL(
	renderable: Blob | string | undefined,
): string | undefined {
	const [imageURL, setImageURL] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (renderable === undefined) {
			setImageURL(undefined);
		} else if (typeof renderable === "string") {
			setImageURL(renderable);
		} else {
			const url = URL.createObjectURL(renderable);
			setImageURL(url);
			return () => {
				URL.revokeObjectURL(url);
			};
		}
	}, [renderable]);

	return imageURL;
}

export async function userImageDataToBase64(
	renderable: Blob | string,
): Promise<string | undefined> {
	if (typeof renderable === "string") {
		return renderable;
	} else {
		return (await getBase64(renderable)) ?? undefined;
	}
}

export function userImageDataFromFloor(img: VelavuFloorImage): UserImageData {
	return {
		name: img.filename,
		renderable: img.url,
		dimensions: {
			width: img.width,
			height: img.height,
		},
	};
}
